// extracted by css-extract-rspack-plugin
export default {"newSegmentButton":"newSegmentButton-bTY67B"};